$(function () {
  $('body').css( 'overflow', 'hidden' );
  var top = $('#top_slide');
  imagesProgress();
  function imagesProgress () {
      var container    = $('#progress'), 
          mv    = $('.p-top-mv'), 
          body         = $('body'), 
          progressBar  = container.find('.p-top-progress__bar'),  
          imgLoad       = imagesLoaded('body'),
          imgTotal      = imgLoad.images.length,
          imgLoaded     = 0,
          current       = 0,
          progressTimer = setInterval(updateProgress, 1000 / 60);
      imgLoad.on('progress', function () {
          imgLoaded++;
      });
      function updateProgress () {
          var target = (imgLoaded / imgTotal) * 100;
          current += (target - current) * 0.1;
          progressBar.css({ width: current + '%' });
          if(current >= 100){
              clearInterval(progressTimer);
              container.addClass('progress-complete');
              mv.addClass('animated');
              body.css( 'overflow', 'auto' );
              setTimeout(function () {
                  top.slick("slickSetOption", "autoplay", true, true);
              }, 0);
          }
          if (current > 99.9) {
              current = 100;
          }
      }
  }
});